<template>
  <CRow>
    <CCol md="3" sm="6" v-for="item in cards" :key="item.key" class="mb-3">
      <CCard class="kpi-card">
        <CCardBody>
          <div class="d-flex align-items-center mb-1">
            <div class="kpi-icon mr-2">
              <CIcon :name="item.icon" size="sm" />
            </div>
            <div class="text-muted small">{{ item.label }}</div>
          </div>
          <div class="h5 mb-0 font-weight-bold">{{ item.value }}</div>
          <div class="small text-muted" v-if="item.denominatorText">{{ item.denominatorText }}</div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'SendTimeKpiCards',
  props: {
    kpis: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    cards() {
      const k = this.kpis || {}
      return [
        {
          key: 'total_sent',
          label: 'Total enviados',
          value: this.number(k.total_sent?.value),
          icon: 'cil-envelope-open',
        },
        {
          key: 'delivery_rate',
          label: 'Tasa de entrega',
          value: this.percent(k.delivery_rate?.value),
          denominatorText: this.denominator(k.delivery_rate),
          icon: 'cil-truck',
        },
        {
          key: 'read_rate',
          label: 'Tasa de lectura',
          value: this.percent(k.read_rate?.value),
          denominatorText: this.denominator(k.read_rate),
          icon: 'cil-notes',
        },
        {
          key: 'response_rate',
          label: 'Tasa de respuesta',
          value: this.percent(k.response_rate?.value),
          denominatorText: this.denominator(k.response_rate),
          icon: 'cil-speech',
        },
        {
          key: 'avg_delivery_to_read_minutes',
          label: 'Tiempo entrega a lectura',
          value: this.minutes(k.avg_delivery_to_read_minutes?.value),
          denominatorText: this.sample(k.avg_delivery_to_read_minutes),
          icon: 'cil-clock',
        },
        {
          key: 'avg_read_to_response_minutes',
          label: 'Tiempo lectura a respuesta',
          value: this.minutes(k.avg_read_to_response_minutes?.value),
          denominatorText: this.sample(k.avg_read_to_response_minutes),
          icon: 'cil-clock',
        },
        {
          key: 'avg_send_to_response_minutes',
          label: 'Tiempo envio a respuesta',
          value: this.minutes(k.avg_send_to_response_minutes?.value),
          denominatorText: this.sample(k.avg_send_to_response_minutes),
          icon: 'cil-clock',
        },
        {
          key: 'error_rate',
          label: 'Tasa de error',
          value: this.percent(k.error_rate?.value),
          denominatorText: this.denominator(k.error_rate),
          icon: 'cil-warning',
        },
      ]
    },
  },
  methods: {
    number(value) {
      if (value === null || value === undefined) {
        return '0'
      }
      return Number(value).toLocaleString('es-MX')
    },
    percent(value) {
      if (value === null || value === undefined) {
        return '0%'
      }
      return `${(Number(value) * 100).toFixed(1)}%`
    },
    minutes(value) {
      if (value === null || value === undefined) {
        return 'N/D'
      }
      return `${Number(value).toFixed(1)} min`
    },
    denominator(payload) {
      if (!payload) {
        return ''
      }
      return `${this.number(payload.numerator)} / ${this.number(payload.denominator)}`
    },
    sample(payload) {
      if (!payload) {
        return ''
      }
      return `Muestra: ${this.number(payload.sample_size || 0)}`
    },
  },
}
</script>

<style scoped>
.kpi-card {
  border: 1px solid #e6e0d1;
}

.kpi-icon {
  width: 26px;
  height: 26px;
  border-radius: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f2ecdc;
  color: #6d664f;
}
</style>
